import { RouterEffect } from './router.effect';
import { StaticDataEffect } from './static-data.effect';
import { UserEffect } from './user.effect';

export const effects: any[] = [RouterEffect, UserEffect, StaticDataEffect];
